<template>
  <v-card elevation="0" :class="isMobile ? 'table-card pl-2 pr-2' : 'table-card'">
    <v-card-title class="pl-0 pt-0">
      {{ $t('queues.reports.queueSummary.title') }}
    </v-card-title>
    <v-card-subtitle class="pl-0 pr-0 d-flex justify-space-between">
      <div>
        <v-icon>mdi-calendar</v-icon>&nbsp;
        <span v-if="scope === 'day'"><strong>{{ startDate.substring(0, 10) }}</strong></span>
        <span v-else v-html="$t('queues.reports.scopeDisplays.range', { start: startDate, end: endDate })" />
      </div>
      <v-btn small color="primary" @click="$emit('openEmailDialog', 'queue_summary')">
        <v-icon left>mdi-email-multiple</v-icon>
        {{ $t('queues.reports.emailDialog.button') }}
      </v-btn>
    </v-card-subtitle>
    <SummaryChart :report-rows="rows.dates" :scope="scope" :hourly="hourly" />
    <v-expansion-panels flat multiple mt-3 v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="text-h6">{{ $t('queues.reports.queueSummary.queueTitle') }}</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <SummaryTable :report-rows="rows.queues" :totals="totals.queues" table="queues" />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="text-h6">{{ $t('queues.reports.queueSummary.dateTitle') }}</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <SummaryTable :report-rows="rows.dates" :totals="totals.dates" table="dates" :selected-queues="selectedQueues" :scope="scope" :hourly="hourly" @refreshData="refreshData" />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="text-h6">{{ $t('queues.reports.queueSummary.agentTitle') }}</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <AgentSummary :report-rows="rows.agents" :totals="totals.agents" :scope="scope" :startDate="startDate" :endDate="endDate" @refreshData="refreshData" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import SummaryChart from './summary_chart'
import SummaryTable from './summary_table'
import AgentSummary from './agent_summary'

export default {
  name: 'queues-reports-queue-summary',
  components: { SummaryChart, SummaryTable, AgentSummary },
  props: {
    reportRows: {
      type: Object,
      required: true
    },
    selectedQueues: {
      type: Array,
      default: () => []
    },
    scope: {
      type: String,
      default: 'month'
    },
    hourly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      panel: [0, 1, 2]
    }
  },
  computed: {
    isMobile () {
      return this.$vuetify.breakpoint.mobile
    },
    rows () {
      if (!this.reportRows.queues || !this.reportRows.dates || !this.reportRows.agents) {
        return {
          queues: [],
          dates: [],
          agents: []
        }
      }
      return {
        queues: this.reportRows.queues.filter(queue => queue.queuename !== null),
        dates: this.reportRows.dates.filter(date => date.date !== null),
        agents: this.reportRows.agents.filter(agent => agent.agent !== null)
      }
    },
    totals () {
      const defaultTotals = {
        queues: {
          calls: 0,
          answered: 0,
          abandon: 0,
          timeout: 0,
          exit: 0,
          avg_hold: 0,
          avg_talk: 0,
          max_talk: 0,
          total_talk: 0
        },
        agents: {
          offered: 0,
          answered: 0,
          min_talk: 0,
          avg_talk: 0,
          max_talk: 0,
          total_talk: 0
        }
      }
      if (!this.reportRows.queues || !this.reportRows.dates || !this.reportRows.agents) {
        return { ...defaultTotals, dates: defaultTotals.queues }
      }
      return {
        queues: this.reportRows.queues.filter(queue => queue.queuename === null)[0] || defaultTotals.queues,
        dates: this.reportRows.dates.filter(date => date.date === null)[0] || defaultTotals.queues,
        agents: this.reportRows.agents.filter(agent => agent.agent === null)[0] || defaultTotals.agents
      }
    },
    startDate () {
      return this.rows.dates[0]?.date || ''
    },
    endDate () {
      return this.rows.dates[this.rows.dates.length - 1]?.date || ''
    }
  },
  methods: {
    refreshData (data) {
      this.$emit('refreshData', data)
    }
  }
}
</script>
